export default "__VITE_ASSET__3e4a0c2f__"